import Joi from 'joi'

import { EntityConstants } from 'constants/EntityConstants'
import { ReplaceBookingDriverDtoInput } from 'generated/graphql'

const ValidationSchema = Joi.object<ReplaceBookingDriverDtoInput>({
  driverId: Joi.number().empty(null).required().label('Driver'),
  vehicleId: Joi.number().empty(null).required().label('Vehicle'),
  isShownInstruction: Joi.boolean().optional().default(false),
  instruction: Joi.string()
    .max(EntityConstants.MAX_NOTE_LENGTH)
    .allow('')
    .allow(null)
    .optional()
    .default('')
    .label('Instruction'),
})

export default ValidationSchema
